/* eslint-disable */

const ThemeChild = {

    init: ($) => {
        ThemeChild.handleAgreeToTerm($);
    },

    ready: ($) => {
        ThemeChild.fixRevSliderCurrencies($);
        ThemeChild.tourSidebar($);
        ThemeChild.itineraryAccordion($);
        ThemeChild.reLoadMatchHeighAfterLazyload($);

        ThemeChild.tourFormDropdown($);

        // In case the user refreshes the page or goes back we can keep the text updated
        ThemeChild.initTourFormDropdownText($);

        // initialize the tooltips
        $('[data-toggle="tooltip"]').tooltip();

        ThemeChild.autofillBillingDetails($);
    },


    /**
     * Handle the clicking off the different event dates for grouped tours
     * @param $
     */
    tourSidebar: function($) {
        const $periods = $('.tour-booking-periods');
        const $periodInput = $('[name="selected_period"]');
        const $li = $periods.find('li');

        $(document).on('click', '#tourBookingForm .price-variation', function(e) {
            const $target = $(e.currentTarget);
            const val = $target.data('value')
            $('#tourBookingForm .price-variation.active').removeClass('active');
            $target.addClass('active');
            // Trigger our room type
            $('#pa_room_type').val(val)
            $('.product-quantity').val(val === 'twin' ? 2 : 1)
            $('#pa_room_type').trigger('change');
        });

        // less then one we don't need this event
        if ($li.length <= 1) {
            return;
        }
        $li.on('click touchstart', function(e) {
            const $target = $(e.currentTarget);
            $periods.find('.selected').removeClass('selected');
            $target.addClass('selected');
            const date = $target.data('date');
            const duration = $target.data('duration');
            window.location.hash = 'period-' + date;

            $periodInput.val(date);

            const singlePrice = $target.data('price-single');
            const twinPrice = $target.data('price-twin');
            const smallestPrice = $target.data('price-smallest');
            const badgeId = $target.data('badge-id');
            const tourDateRange = $target.data('date-range');
            const tourLeader = $target.data('tour-leader-id');

            $('.attribute-duration .tours-tabs__info__item__title').html(duration + ' days');
            // disable tour guide
            $('.tour-guide').addClass('hidden');
            // show one for selected period
            $('.tour-guide[data-tour-guide-id="' + tourLeader + '"]').removeClass('hidden');

            const $priceDecoration = $('.price-decoration');
            // reset badges
            $priceDecoration.find('[data-badge-id]').addClass('hidden');

            $('.price-decoration-single').html(singlePrice);
            $('.price-decoration-twin').html(twinPrice);
            $('.price-from').html(smallestPrice);
            $('.tour-date-range').replaceWith(tourDateRange);

            $priceDecoration.find('[data-badge-id="' + badgeId + '"]').removeClass('hidden');

            // Trigger our room type
            $('#pa_room_type').trigger('change');

            // replace the pdf link for the selected date
            var $pdfLink =  $('.tour-pdf-button');
            var href = $pdfLink.attr('href');
            href = href.substr(0, href.indexOf('tour_date=') + 10) + date;
            $pdfLink.attr('href', href);

        });

        if (window.location.hash.indexOf('#period-') === 0) {
            var date = window.location.hash.replace('#period-', '');
            $periods.find('[data-date="' + date + '"]').trigger('click');
        }


    },

    itineraryAccordion: function($){
        $("#itinerary_accordion").click(function(e){
            e.preventDefault();

            var $iteneryContainer = $('.panel-group.accordion');

            if($("#itinerary_accordion").html() == 'Collapse All'){
                $iteneryContainer.find('.accordion__item__link').addClass('collapsed');
                $iteneryContainer.find('.panel-collapse').addClass('collapse');
                $iteneryContainer.find('.panel-collapse').removeClass('in');
                $('#itinerary_accordion').html('Expand All');
            }else{
                $iteneryContainer.find('.accordion__item__link').removeClass('collapsed');
                $iteneryContainer.find('.panel-collapse').removeClass('collapse');
                $iteneryContainer.find('.panel-collapse').addClass('in');
                $('#itinerary_accordion').html('Collapse All');
                $iteneryContainer.find('.panel-collapse').removeAttr( 'style' );
            }

            return false;
        });
    },

    handleAgreeToTerm: function($){
        /*
         * http://stackoverflow.com/questions/9471347/returning-false-in-first-of-multiple-form-submission-handlers
         */

        var $proceed_btn = $('#place_order');
        var $form = $proceed_btn.closest('form');
        var $agree = $('#agree-to-terms');
        var $msg = $('#agree-to-terms-msg');
        $form.on('submit', function(e){
            if(!$agree.prop('checked')){
                $msg.css('display','block');

                //stop wc script, this relies on this script being included before wc checkout.js
                e.stopImmediatePropagation();
                return false;
            }
            $msg.css('display','none');
        });
        $agree.on('change', function(){
            if($agree.prop('checked')){
                $msg.css('display','none');
            }
        });
    },

    reLoadMatchHeighAfterLazyload: function($){
        $(document).on('lazybeforeunveil', function(){
            $.fn.matchHeight._update();
        });
    },

    /**
     * Find any currencies on the rev slider and update them to their appropriate value
     */
    fixRevSliderCurrencies: function($) {
        var currencies = $('.is-currency');
        if (currencies.length > 0) {
            //find our currency
            var currency = woocs_current_currency.name.toLowerCase();
            //hide all currency objects
            currencies.each(function() {
                var val = parseInt($(this).html().replace('$', '').replace(',', ''));
                val *= woocs_current_currency.rate;
                val = val.formatMoney();
                $(this).html('$' + val);
            });
            //show currency objects for us

            //set all currency types to whichever we have selected
            $('.is-currency-type').html(woocs_current_currency.name);
        }
    },

    /**
     * We count how long the user has been on the site in total using local storage. This is to raise
     * our custom events.
     */
    countTimeOnSite: function($) {

        // reset the value to 0 initially
        localStorage.setItem( "total-time-on-site", 0);

        ThemeChild.timeOnSiteCounter = setInterval( function() {
            //increment every second
            var currentTime = localStorage.getItem( "total-time-on-site");
            localStorage.setItem( "total-time-on-site", ++currentTime);
            //every 5 seconds raise a custom event
            if (currentTime % 5 == 0) {
                $(window).trigger('active-time', currentTime);
            }
        }, 1000);
    },

    autofillBillingDetails: function($) {

        const syncBillingFields = () => {
            if (!$('#billing_same_as_shipping').is(':checked')) {
                return;
            }

            $('#billing_first_name').val($('#traveller_first_name').val());
            $('#billing_last_name').val($('#traveller_last_name').val());
            $('#billing_country').val($('#traveller_country').val());
            $('#billing_address_1').val($('#traveller_address_1').val());
            $('#billing_address_2').val($('#traveller_address_2').val());
            $('#billing_postcode').val($('#traveller_postcode').val());
            $('#billing_city').val($('#traveller_city').val());
            $('#billing_state').val($('#traveller_state').val());
            $('#billing_phone').val($('#traveller_phone').val());
            $('#billing_email').val($('#traveller_email').val());
            // Trigger change to visually update the selected country/state
            $('#billing_country').trigger('change');
            $('#billing_state').trigger('change');
            $('.woocommerce-billing-fields__field-wrapper > .form-row').hide()
        }

        $(document).on('change', '.woocommerce-traveller-fields input, .woocommerce-traveller-fields select', () =>{
            syncBillingFields()
        })

        $('#traveller_country').on('change', function() {
            const country = $('#traveller_country').val()
            if (country !== 'AU') {
                $('#aus_only_details').hide()
            } else {
                $('#aus_only_details').show()
            }
            console.log(country)
        })


        $('#traveller_country').on('change', function() {
            const country = $('#traveller_country').val()
            if (country !== 'AU') {
                $('#aus_only_details').hide()
            } else {
                $('#aus_only_details').show()
            }
        })

        $('#billing_same_as_shipping').on('change', function() {

            $('.woocommerce-billing-fields__field-wrapper > .form-row').show()

            if (!$(this).is(':checked')) {
                return;
            }

            syncBillingFields()
        });
    },

    tourFormDropdown: function($) {
        $('#form-dropdown').on('click tap', function() {
            $('#form-dropdown-fields').toggleClass('hidden');

            $('#dropdown-icon').toggleClass('fa-chevron-down fa-chevron-up');
        });

        $('#pa_room_type').on('change', function() {
            var $selectedOption = $(this).find('option:selected');

            if (!$selectedOption.val()) {
                return;
            }

            $('#dropdown-room-label').html($selectedOption.text());
        });

        $('.product-quantity').on('change', function() {
            var numberGuests = $(this).val();

            if (!numberGuests) {
                return;
            }

            $('#dropdown-guest-label').html(numberGuests);
        });
    },

    initTourFormDropdownText: function($) {
        var $roomType = $('#pa_room_type').find('option:selected');
        var numberGuests = $('.product-quantity').val();

        if ($roomType.val()) {
            $('#dropdown-room-label').html($roomType.text());
        }

        if (numberGuests > 0) {
            $('#dropdown-guest-label').html(numberGuests);
        }
    }
};


Number.prototype.formatMoney = function(){
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 0 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

export default ThemeChild;
